import { customersDepartmentsV2Ops } from "../../api/operations";
import { ROLE } from "../../Auth/useRole";
import { entityFactory } from "../../hooks/useEntity";
import { defineEntity } from "../../api/entity";

export const conf = defineEntity({
  ...entityFactory("egate-departments"),
  endpoint: "customers/departments",
  operations: customersDepartmentsV2Ops,
  roleView: [ROLE.CUSTOMER_VIEW, ROLE.CUSTOMER_ADMIN],
  roleAdmin: [ROLE.CUSTOMER_ADMIN],
  singularName: (t) => t("eGate Department"),
  name: (t) => t("eGate Departments"),
  apiVersion: "v2",
});

export default conf;
